var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import { Box, ListItemIcon, ListItemText, MenuItem, useTheme, } from "@mui/material";
import { RoundActionIconButton } from "../../components/Buttons/ActionIconButton/RoundActionIconButton";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { useEffect, useState } from "react";
import ScreenshotMonitorIcon from "@mui/icons-material/ScreenshotMonitor";
import { MenuInput } from "../../utils/MenuInput";
import { LoadedFileChip } from "./LoadedFileChip";
// import protein_icon from "../../static/images/protein_icon.png";
export default function ChatInputOptions({ initSelectedFile, initSelectedSystem, waiting, setSelectedFileCallback, setSelectedSystemCallback, vss, }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const [selectedFile, setSelectedFile] = useState(initSelectedFile);
    const [selectedSystem, setSelectedSystem] = useState(initSelectedSystem);
    const theme = useTheme();
    const handleFileChange = (file) => {
        setSelectedFile(file ? file : null);
        handleClose();
    };
    const handleDeleteFile = () => {
        setSelectedFile(null);
    };
    const handleDeleteSystem = () => {
        setSelectedSystem(null);
    };
    useEffect(() => {
        setSelectedFile(initSelectedFile);
    }, [initSelectedFile]);
    useEffect(() => {
        setSelectedSystem(initSelectedSystem);
    }, [initSelectedSystem]);
    useEffect(() => {
        setSelectedFileCallback(selectedFile);
    }, [selectedFile]);
    useEffect(() => {
        setSelectedSystemCallback(selectedSystem);
    }, [JSON.stringify(selectedSystem)]); // maybe just use the system IDs
    const buttonColor = theme.palette.getContrastText("#4d4d4d");
    const handleSelectSystem = (systemData) => {
        setSelectedSystem(systemData);
        handleClose();
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Box, { children: [selectedFile && (_jsx(LoadedFileChip, { fileName: selectedFile.name, handleDelete: handleDeleteFile, buttonColor: buttonColor })), selectedSystem && (_jsx(LoadedFileChip, { fileName: selectedSystem.name, handleDelete: handleDeleteSystem, buttonColor: buttonColor })), _jsx(ViewerScreenshotButton, { callback: handleFileChange, disabled: waiting, buttonColor: buttonColor }), _jsx(ImageUploadButton, { callback: handleFileChange, disabled: waiting, buttonColor: buttonColor })] }), _jsx(_Fragment, {})] }));
}
// const SystemMenuItem = ({
//   handleSelectSystem,
//   handleCloseParentPopover,
//   vss,
// }: {
//   handleSelectSystem: (systemData: LLMChatSystemData | null) => void;
//   handleCloseParentPopover: () => void;
//   vss: VSS;
// }) => {
//   const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
//   const handleOpenPopover = (event: any) => {
//     setAnchorEl(event.currentTarget);
//   };
//   const handleClosePopover = () => {
//     setAnchorEl(null);
//     handleCloseParentPopover();
//   };
//   const open = Boolean(anchorEl);
//   const [loaded_structures] = vss(
//     (state) => [state.loaded_structures],
//     shallow
//   );
//   let systemsArr: System[] = [];
//   loaded_structures.forEach((system) => {
//     const groupSystems = recursiveGetAllChildSystems(system);
//     systemsArr.push(...groupSystems);
//   });
//   const handleSystemClick = async (system: System) => {
//     const systemID = system.moleculeID;
//     const isSDF = system.type === FileType.sdf;
//     const pyodide = window.pyodideWorker;
//     if (!systemID || !pyodide) {
//       dispatchNotificationEvent({
//         message: "Error obtaining system data.",
//         type: "error",
//       });
//       handleClosePopover();
//       return;
//     }
//     const mols = await getMoleculeTopologyAndCoordinates(
//       isSDF,
//       systemID,
//       pyodide
//     );
//     let systemData: LLMChatSystemData | null = null;
//     if (mols && mols.length > 0) {
//       // Filter molecule data to only include specific fields
//       const allowedFields = [
//         "beta",
//         "bonds",
//         "bondtype",
//         "chain",
//         "charge",
//         "coords",
//         "element",
//         "fstep",
//         "name",
//         "numAtoms",
//         "numFrames",
//         "resid",
//         "resname",
//         "serial",
//       ];
//       const molsFilt = mols.map((mol) => {
//         const filteredMol: any = {};
//         for (const field of allowedFields) {
//           if (field in mol) {
//             filteredMol[field] = mol[field];
//           }
//         }
//         return filteredMol;
//       });
//       systemData = {
//         name: system.name,
//         molecules: molsFilt,
//       };
//     }
//     handleSelectSystem(systemData);
//     // handleClosePopover();
//   };
//   return (
//     <>
//       <MenuItem onClick={handleOpenPopover} disabled={systemsArr.length === 0}>
//         <ListItemIcon>
//           <ListItemIcon>
//             <img
//               src={protein_icon}
//               style={{
//                 width: "20px",
//                 height: "20px",
//               }}
//               alt="discord"
//             />
//           </ListItemIcon>
//         </ListItemIcon>
//         <ListItemText>Add System</ListItemText>
//       </MenuItem>
//       <Popover
//         id={open ? "selecion-copy-popover" : undefined}
//         open={open}
//         anchorEl={anchorEl}
//         onClose={handleClosePopover}
//         anchorOrigin={{
//           vertical: "bottom",
//           horizontal: "left",
//         }}
//         transformOrigin={{
//           vertical: "bottom",
//           horizontal: "right",
//         }}
//       >
//         <MenuList
//           dense
//           sx={{
//             maxHeight: "80vh",
//             overflow: "auto",
//           }}
//         >
//           {systemsArr.map((system, i) => (
//             <MenuItem
//               key={`sel-copy-to-${system.moleculeID ? system.moleculeID : i}`}
//               onClick={(e) => {
//                 handleSystemClick(system);
//               }}
//             >
//               <ListItemText>{system.name}</ListItemText>
//             </MenuItem>
//           ))}
//         </MenuList>
//       </Popover>
//     </>
//   );
// };
const ViewerScreenshotButton = ({ callback, disabled, buttonColor, }) => {
    const handleClick = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const molstar = window.molstar;
        if (!molstar)
            return;
        const imageDataUri = yield ((_a = molstar.helpers.viewportScreenshot) === null || _a === void 0 ? void 0 : _a.getImageDataUri());
        if (!imageDataUri)
            return;
        const imageBlob = yield fetch(imageDataUri).then((res) => res.blob());
        const imageFile = new File([imageBlob], "screenshot", {
            type: "image/png",
        });
        callback(imageFile);
    });
    return (_jsx(RoundActionIconButton, Object.assign({ size: "small", onClick: handleClick, baseColor: buttonColor, disabled: disabled, isLabel: true, tooltipMsg: "Viewer screenshot" }, { children: _jsx(ScreenshotMonitorIcon, { fontSize: "small" }) })));
};
// const ScreenshotMenuItem = ({
//   handleFileChange,
// }: {
//   handleFileChange: (file: File | undefined | null) => void;
// }) => {
//   const handleClick = async () => {
//     const molstar = window.molstar;
//     if (!molstar) return;
//     const imageDataUri =
//       await molstar.helpers.viewportScreenshot?.getImageDataUri();
//     if (!imageDataUri) return;
//     const imageBlob = await fetch(imageDataUri).then((res) => res.blob());
//     const imageFile = new File([imageBlob], "screenshot", {
//       type: "image/png",
//     });
//     handleFileChange(imageFile);
//   };
//   return (
//     <MenuItem onClick={handleClick}>
//       <ListItemIcon>
//         <ScreenshotMonitorIcon fontSize="small" />
//       </ListItemIcon>
//       <ListItemText>Viewer screenshot</ListItemText>
//     </MenuItem>
//   );
// };
const ImageUploadButton = ({ callback, disabled, buttonColor, }) => {
    const handleChange = (event) => {
        var _a;
        const file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
        callback(file);
    };
    return (_jsx(RoundActionIconButton, Object.assign({ size: "small", onClick: handleChange, baseColor: buttonColor, disabled: disabled, isLabel: true, tooltipMsg: "Upload image" }, { children: _jsxs(_Fragment, { children: [_jsx("input", { multiple: true, type: "file", id: "multi-file-upload", hidden: true, onChange: handleChange, accept: ".png,.jpeg" }), _jsx(UploadFileIcon, { fontSize: "small" })] }) })));
};
const FileLoadMenuItem = ({ handleFileChange, }) => {
    const handleChange = (event) => {
        var _a;
        const file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
        handleFileChange(file);
    };
    return (_jsx(MenuInput, Object.assign({ handleChange: handleChange, accept: ".png,.jpeg" }, { children: _jsxs(MenuItem, Object.assign({ onClick: () => { }, dense: true }, { children: [_jsx(ListItemIcon, { children: _jsx(UploadFileIcon, { fontSize: "small" }) }), _jsx(ListItemText, { children: "Upload image" })] })) }), "sidebar-load-files-wrap"));
};
